module.exports = __webpack_public_path__ + "static/media/work_check.9c854d35.svg";